import React, {CSSProperties} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Apla} from "@pg-design/apla-module";
import {elevation} from "@pg-design/elevation";
import {calculateRemSize, flexAbsoluteCenter, h100, w100} from "@pg-design/helpers-css";
import {ChevronDownIcon} from "@pg-design/icons-module";
import {SystemModal} from "@pg-design/modal-module";

export interface ExpandablePanelProps {
    isOpen: boolean;
    handleClose: () => void;
    children: React.ReactNode;
    className?: string;
    textContentCss?: CSSProperties;
}

export const ExpandablePanel = (props: ExpandablePanelProps) => {
    return (
        <>
            <Wrapper isExpanded={props.isOpen}>
                <div css={buttonWrap}>
                    <button type="button" onClick={props.handleClose}>
                        <ChevronDownIcon wrapperSize="4.8" size="2.4" wrapperColor="white" wrapperType="circle" css={elevation(2)} />
                    </button>
                </div>
                <div css={[flexAbsoluteCenter, w100, {height: "auto"}]}>
                    <SystemModal.Content className={props.className} css={containerStyle} textStyle={props.textContentCss}>
                        {props.children}
                    </SystemModal.Content>
                </div>
            </Wrapper>
            {props.isOpen && <Apla css={aplaStyle} applyOn={<div />} />}
        </>
    );
};

const Wrapper = styled.div<{isExpanded: boolean}>`
    ${({theme, isExpanded}) => css`
        max-height: ${isExpanded ? "calc(100dvh - 60px)" : 0};
        transition: all ${theme.transition.timingFunction} ${theme.transition.duration};
        position: fixed;
        left: 0;
        bottom: ${isExpanded ? 0 : `-${calculateRemSize(3)}`};
        z-index: 2002;
        height: auto;
        width: 100%;
        max-width: 100vw;
        ${elevation(1)};
        overflow: visible;

        @media (min-width: ${theme.breakpoints.md}) {
            display: none;
        }
    `}
`;

const containerStyle = css`
    border-radius: ${calculateRemSize(2)} ${calculateRemSize(2)} 0 0;
    overflow: hidden;
    z-index: 1;
`;

const buttonWrap = css`
    inset: 0 0 auto;
    display: flex;
    justify-content: center;
    transform: translateY(50%);
    width: 4.8rem;
    margin: 0 auto;
    position: relative;
    z-index: 2;
`;

const aplaStyle = (theme: Theme) => css`
    position: fixed;
    top: 0;
    ${w100};
    ${h100};
    background-color: ${theme.colors.secondary};
    z-index: 2001;
    opacity: 0.75;
`;
import React, {CSSProperties} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {Apla} from "@pg-design/apla-module";
import {elevation} from "@pg-design/elevation";
import {calculateRemSize, flexAbsoluteCenter, h100, w100} from "@pg-design/helpers-css";
import {ChevronDownIcon} from "@pg-design/icons-module";
import {SystemModal} from "@pg-design/modal-module";

export interface ExpandablePanelProps {
    isOpen: boolean;
    handleClose: () => void;
    children: React.ReactNode;
    className?: string;
    textContentCss?: CSSProperties;
}

export const ExpandablePanel = (props: ExpandablePanelProps) => {
    return (
        <>
            <Wrapper isExpanded={props.isOpen}>
                <div css={buttonWrap}>
                    <button type="button" onClick={props.handleClose}>
                        <ChevronDownIcon wrapperSize="4.8" size="2.4" wrapperColor="white" wrapperType="circle" css={elevation(2)} />
                    </button>
                </div>
                <div css={[flexAbsoluteCenter, w100, {height: "auto"}]}>
                    <SystemModal.Content className={props.className} css={containerStyle} textStyle={props.textContentCss}>
                        {props.children}
                    </SystemModal.Content>
                </div>
            </Wrapper>
            {props.isOpen && <Apla css={aplaStyle} applyOn={<div />} />}
        </>
    );
};

const Wrapper = styled.div<{isExpanded: boolean}>`
    ${({theme, isExpanded}) => css`
        max-height: ${isExpanded ? "calc(100dvh - 60px)" : 0};
        transition: all ${theme.transition.timingFunction} ${theme.transition.duration};
        position: fixed;
        left: 0;
        bottom: ${isExpanded ? 0 : `-${calculateRemSize(3)}`};
        z-index: 2002;
        height: auto;
        width: 100%;
        max-width: 100vw;
        ${elevation(1)};
        overflow: visible;

        @media (min-width: ${theme.breakpoints.md}) {
            display: none;
        }
    `}
`;

const containerStyle = css`
    border-radius: ${calculateRemSize(2)} ${calculateRemSize(2)} 0 0;
    overflow: hidden;
    z-index: 1;
`;

const buttonWrap = css`
    inset: 0 0 auto;
    display: flex;
    justify-content: center;
    transform: translateY(50%);
    width: 4.8rem;
    margin: 0 auto;
    position: relative;
    z-index: 2;
`;

const aplaStyle = (theme: Theme) => css`
    position: fixed;
    top: 0;
    ${w100};
    ${h100};
    background-color: ${theme.colors.secondary};
    z-index: 2001;
    opacity: 0.75;
`;
